import React from 'react';
import ColorBox from '../../ColorBox';
import Bold from '../../Bold';
import { capitalizeFirstLetter } from '../../../util/helperFunctions';
import Spacer from '../../Spacer';
import styled from 'styled-components';

const FlexParagraph = styled.p`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  &.marginless:not(:last-child) {
    margin-bottom: 0;
  }
`;

const MarginBottom = styled.li`
  margin-bottom: 15px;
`;

export default function ColorCodePreamble({ colorCounts, colors }) {
  return (
    <ul>
      {Object.keys(colorCounts).map((colorCode, index) => {
        const currentArray = Object.values(colorCounts[colorCode]);
        return (
          <MarginBottom key={`animalCountByColorCode-${colorCode}-${index}`}>
            <FlexParagraph className="marginless">
              <ColorBox color={colors[index]} />
              <Spacer>
                <Bold>{capitalizeFirstLetter(colorCode)}:</Bold> Between {Math.min(...currentArray)} and{' '}
                {Math.max(...currentArray)}.
              </Spacer>
            </FlexParagraph>
            <p> ({Math.floor(currentArray.reduce((a, b) => a + b, 0) / currentArray.length)} on average per day)</p>
          </MarginBottom>
        );
      })}
    </ul>
  );
}
